import type { CredentialPage, CredentialRow } from '@rtkwlf/rendall';

export interface CredentialedScanningRow extends CredentialRow {
  credScanningTypeStr: string;
  targetStr: string;
}

export enum CredentialedScanningType {
  Up = 'up',
  Usk = 'usk',
}

export type CredentialSelectFn =
  | ((data: CredentialPage) => CredentialedScanningRow[])
  | undefined;

export type CredTypeOptions = {
  text: string;
  value: CredentialedScanningType;
};
